export class Attachment {
  StaffID;
  DocType;
  DocID;
  Doc;
  DocMime;
  AddBy;
  Seq;
  DocURL;
  DocFile;
  DateModify;
  DateAdd;
  IsImageFile;
  IsDeleted;
  RecDel;
  constructor() {
    this.StaffID = "";
    this.DocType = "";
    this.DocID = "";
    this.Doc = "";
    this.DocMime = "";
    this.AddBy = "";
    this.Seq = "";
    this.DocURL = "";
    this.DocFile = "";
    this.DateAdd = "1900-01-01";
    this.ModifyBy = "";
    this.DateModify = "1900-01-01";
    this.IsImageFile = false;
    this.IsDeleted = false;
    this.RecDel = false
  }
}



// WEBPACK FOOTER //
// ./src/model/Attachment.js